import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { AssetActionsProvider, AssetActionsDropdown, AssetActionButton, ACTION_IDS } from 'asset-actions-lib';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import formActions from 'asset-actions-lib-forms';
import { getAnalyticsDateRange
// @ts-expect-error untyped dependency
} from 'FormsUI/selectors/Dashboard';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import useActionsLib from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/HoverContent/hooks/useActionsLib';
import moveToFolderAction from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/HoverContent/actionOverrides/moveToFolderAction';
import viewNonHSInformationAction from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/HoverContent/actionOverrides/viewNonHSInformationAction';
import convertNonHSFormAction from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name/HoverContent/actionOverrides/convertNonHSAction';
import { useGetAccessControlsQuery } from '../../../../../../../__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService.hooks';
import FORM_TYPES from 'ui-forms-editor-automation-lib/constants/FORM_TYPES';
import { getAISettingsUrl } from 'FormsUI/utils/UrlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HoverContentActionsLib({
  crmObject
}) {
  const {
    data,
    loading
  } = useGetAccessControlsQuery();
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  const dateRange = useSelector(getAnalyticsDateRange);
  const {
    handleActionError,
    handleActionSuccess,
    handleOnTrackEvent
  } = useActionsLib(String(formType));
  const {
    actionIdsToExclude,
    isPopup
  } = useMemo(() => {
    if (formType === FORM_TYPES.FLOW) {
      return {
        isPopup: true,
        // will need to update if theres other things we don't wanna do here
        actionIdsToExclude: [FORM_ACTION_IDS.CREATE_CUSTOMER_AGENT_ACTION, FORM_ACTION_IDS.CLONE, FORM_ACTION_IDS.SMART_COPY, ACTION_IDS.EDIT, ACTION_IDS.COMPARE, ACTION_IDS.MANAGE_ACCESS, ACTION_IDS.COMMENT]
      };
    }
    return {
      isPopup: false,
      actionIdsToExclude: [FORM_ACTION_IDS.CLONE, ACTION_IDS.EDIT, FORM_ACTION_IDS.SMART_COPY]
    };
  }, [formType]);
  return /*#__PURE__*/_jsx(AssetActionsProvider, {
    actions: formActions,
    actionsConfigOverrides: [
    /**
     * The three overrides below won't be migrated to asset-actions-lib.
     *
     * - "Move to folder" depends on framework-listing-lib's internal implementation and we (#marketing-platform) need a better strategy for this action before making it "shareable".
     * - Both "View non HS Info" and "Convert non HS Form" are heavily dependant on redux + several utility methods that live inside FormsUI which makes it super hard to migrate over.
     */
    moveToFolderAction, viewNonHSInformationAction, convertNonHSFormAction],
    crmObject: crmObject,
    nonCrmObject: {
      type: 'DASHBOARD',
      dateRange
    },
    onActionSuccess: handleActionSuccess,
    onActionError: handleActionError,
    trackerProps: {
      applicationId: 'FormsUI',
      onTrackEvent: handleOnTrackEvent
    },
    layoutUse: "hover-actions",
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "popupFormDeprecation.dashboardTooltip.title"
        }),
        disabled: !isPopup,
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(AssetActionButton, {
            disabled: isPopup,
            actionId: ACTION_IDS.EDIT
          }), /*#__PURE__*/_jsx(Tooltip, {
            placement: "right",
            title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              elements: {
                Link
              },
              options: {
                href: getAISettingsUrl(),
                external: true
              },
              message: "newCreateForm.disabledTooltip.generativeAi_jsx"
            }),
            disabled: !loading && (data === null || data === void 0 ? void 0 : data.generativeAiEnabled),
            children: /*#__PURE__*/_jsx(AssetActionButton, {
              disabled: isPopup || loading || !(data !== null && data !== void 0 && data.generativeAiEnabled),
              actionId: FORM_ACTION_IDS.SMART_COPY
            })
          }), /*#__PURE__*/_jsx(AssetActionButton, {
            disabled: isPopup,
            actionId: FORM_ACTION_IDS.CLONE
          })]
        })
      }), /*#__PURE__*/_jsx(AssetActionsDropdown, {
        actionIdsToExclude: actionIdsToExclude
      })]
    })
  });
}